import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ArticleNavbar from './components/ArticleNavbar';
import ArticleFooter from './components/ArticleFooter';
import { BlogPostingSchema } from '@/components/base/SchemaOrg';

export default function SpreadsheetComparison() {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, []);
  return (
    <>
      <BlogPostingSchema
        headline="GTBuy vs Kakobuy vs Superbuy: Full Spreadsheet Platform Comparison"
        description="Complete three-way comparison of GTBuy, Kakobuy, and Superbuy spreadsheet platforms. Compare update speed, category coverage, ease of use, and pricing to find the best fit for your sourcing needs."
        url="https://gtbuyspreadsheet.living/spreadsheet-comparison"
        datePublished="2026-07-01"
        dateModified="2026-07-01"
      />
      <ArticleNavbar />
      <article className="pt-32 pb-12 px-6 md:px-10">
        <div className="max-w-[720px] mx-auto">
          <h1 className="text-foreground-900 font-heading text-3xl md:text-[42px] font-bold leading-[1.15]">
            GTBuy vs Kakobuy vs Superbuy: Full Spreadsheet Platform Comparison
          </h1>
          <p className="text-foreground-500 mt-6 text-lg leading-relaxed">
            This comparison guide is coming soon. In the meantime, check out our main article on{' '}
            <Link to="/what-is-gtbuy-spreadsheet" className="text-primary-500 hover:text-primary-600 border-b border-primary-500 transition-colors">
              What Is GTBuy Spreadsheet
            </Link>{' '}
            which includes a platform comparison table, or return to the{' '}
            <Link to="/" className="text-primary-500 hover:text-primary-600 border-b border-primary-500 transition-colors">
              GTBuy Spreadsheet Hub
            </Link>{' '}
            to browse product categories.
          </p>
        </div>
      </article>
      <ArticleFooter />
    </>
  );
}